import { InvalidArgumentException } from '@diziner/Exceptions/InvalidArgumentException';
export class PreLoadIndicator {
    constructor(element) {
        this._progressMin = 0;
        this._progressMax = 100;
        this._progress = 0;
        this._element = element;
        const svgPath = this._element.querySelector('path');
        if (svgPath === null) {
            throw new InvalidArgumentException('Supplied SVGElement does not contain a SVGPathElement');
        }
        this._svgPath = svgPath;
        const svgText = this._element.querySelector('text');
        if (svgText === null) {
            throw new InvalidArgumentException('Supplied SVGElement does not contain a SVGTextElement');
        }
        this._svgText = svgText;
        const svgPathStroke = this._svgPath.style.strokeDasharray;
        if (svgPathStroke === null) {
            throw new InvalidArgumentException('Supplied SVGTextElement does not have the "stroke-dasharray" attribute');
        }
        this._loadingMax = parseFloat(svgPathStroke);
    }
    get getProgressMin() {
        return this._progressMin;
    }
    get getProgressMax() {
        return this._progressMax;
    }
    setProgressMin(value) {
        this._progressMin = value;
        return this;
    }
    setProgressMax(value) {
        this._progressMax = value;
        return this;
    }
    setProgress(progress) {
        this._progress = progress;
        const progressPercentage = (this._progress / (this._progressMax - this._progressMin));
        this._svgPath.style.strokeDashoffset = (this._loadingMax
            - Math.abs(0
                - (progressPercentage * this._loadingMax))).toString();
    }
}
export default PreLoadIndicator;
